(ns io.daskul.tutorial.webapp.components.footer
  "Shared footer — Powered by Klei + build info.
   Used in main layout and login page."
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]))

(defui app-footer []
  ($ ui/group {:justify "center" :py "md" :gap 6}
    ($ ui/text {:size "xs" :c "dimmed"} "Powered by")
    ($ ui/anchor {:href "https://klei.ph" :target "_blank" :underline "never"
                  :style {:display "inline-flex" :align-items "center" :gap 4}}
      ($ :img {:src "/klei-icon.svg" :alt "Klei" :width 16 :height 16})
      ($ ui/text {:size "xs" :c "dimmed" :fw 600} "Klei"))))
